import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  margin-bottom: ${({ theme }) => theme.CONSTANTS.XH * 5}px;
  z-index: 15;
`;

export const Position = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: ${({ theme }) => theme.CONSTANTS.XH * 5}px;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 85%;
  border: 1px solid ${({ theme }) => theme.THEME.grayText};
  border-radius: 12px;
  padding: 16px;
  position: relative;
`;

export const Prefix = styled.span`
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 24}px;
  color: ${({ theme }) => theme.THEME.white};
  font-family: "Sora", sans-serif;
  margin-bottom: 6px;

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;

export const StyledInput = styled.input`
  background: transparent;
  border: none;
  border-bottom: 1px solid ${({ theme }) => theme.THEME.grayText};
  color: ${({ theme }) => theme.THEME.white};
  padding: 6px 4px;
  font-family: "Inter", sans-serif;
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 26}px;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.THEME.neonBlue};
  }

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 7}px;
  }
`;
